import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';

import BidPlans from '../BidPlans/BidPlans';

import { useAccountInfo, useRefreshAccountInfo } from 'src/shared/hooks/useAccountInfo';

import { AgencySelection } from '../../products/agency-selection';
import { appKeys } from '../../../utils/constants';
import { BasicUserPlans } from '../BasicUserPlans/BasicUserPlans';
import { BidSummaryState } from 'src/store/reducers/bidssummary';
import { getDynamicProductPrices } from '../../../store/actions';
import { ModalPopUp } from '../../common/modals/ModalPopUp';
import { useSetBreadcrumb } from 'src/shared/hooks';

type PropsFromRedux = Partial<ConnectedProps<typeof connector>>;

type Props = PropsFromRedux &
  RouteComponentProps & {
    productPrices: { countyPrice: number; statePrice: number; nationalPrice: number };
  };

interface ReduxState {
  accountinfo: { agencySelection: boolean };
  shared: { productPrices: { countyPrice: number; statePrice: number; nationalPrice: number } };
  bidssummary: BidSummaryState;
}

export const Plans = ({ bidssummary, productPrices }: Props) => {
  useRefreshAccountInfo();

  const dispatch = useDispatch();
  const [agencySelection, setAgencySelection] = useState(false);

  const {
    accountInfo: { products },
  } = useAccountInfo();

  const {
    location: { search },
  } = useHistory();

  const { results } = bidssummary || {} as any;
  const { bidName } = results || {};

  const ag: string | null = new URLSearchParams(search).get('ag');
  const bidId: string | null = new URLSearchParams(search).get('bidId');

  useEffect(() => {
    if (ag && ag === 'true' && !bidId) {
      setAgencySelection(true);
    }
  }, [ag, bidId]);

  useSetBreadcrumb({
    component: '',
    page: 'Supplier Plans',
    title: `${appKeys.headers.bidPlans}`,
    altname: appKeys.headers.plans,
    name: bidName as string,
    id: bidId as string,
  });

  useEffect(() => {
    dispatch(getDynamicProductPrices());
  }, [dispatch]);

  const toggleModal = useCallback(() => {
    return setAgencySelection(!agencySelection);
  }, [agencySelection]);

  return (
    <div className='container' id='purchase-plan'>
      <div className='row detailViewWrapper'>
        <div className='col-12'>
          <div className='colWrapper clearfix'>
            {bidId ? (
              <BidPlans bidId={bidId} productPrices={productPrices} toggleModal={toggleModal} />
            ) : (
              <BasicUserPlans productPrices={productPrices} toggleModal={toggleModal} />
            )}
          </div>
        </div>
      </div>
      <ModalPopUp
        size='lg'
        title='Upgrade to free agency'
        closeModal={toggleModal}
        isOpen={agencySelection === true}
        backdrop='static'
      >
        <AgencySelection products={products} toggleAgencySelection={toggleModal} />
      </ModalPopUp>
    </div>
  );
};

const connector = connect((state: ReduxState) => ({
  productPrices: state?.shared?.productPrices || false,
  bidssummary: state?.bidssummary || {},
}));

export default connector(Plans);
